(() => {
  const updatePage = () => {
    const sticky = document.querySelector('[data-listicle-sticky]');
    if (sticky) {
      const explicitStart = document.querySelector('[data-listicle-sticky-start]');
      const startReached = explicitStart
        ? explicitStart.getBoundingClientRect().top <= window.innerHeight * 0.7
        : window.scrollY >= document.documentElement.scrollHeight * 0.2;
      const offers = document.querySelectorAll('[data-listicle-offer], [data-cl10m-offer]');
      const offerVisible = [...offers].some((offer) => {
        const bounds = offer.getBoundingClientRect();
        return bounds.top < window.innerHeight && bounds.bottom > 0;
      });
      sticky.classList.toggle('is-visible', startReached && !offerVisible);
    }

    document.querySelectorAll('[data-listicle-timeline]').forEach((timeline) => {
      const fill = timeline.querySelector('[data-listicle-timeline-fill]');
      const items = [...timeline.querySelectorAll('[data-listicle-timeline-item]')];
      if (!fill || !items.length) return;
      const marker = window.innerHeight * 0.64;
      let lastActive = null;
      items.forEach((item) => {
        const active = item.getBoundingClientRect().top <= marker;
        item.classList.toggle('is-active', active);
        if (active) lastActive = item;
      });
      fill.style.height = lastActive ? `${lastActive.offsetTop + 32}px` : '0px';
    });
  };

  let frameRequested = false;
  const requestUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(() => {
      frameRequested = false;
      updatePage();
    });
  };

  // On subfolder markets (/en-eu, /pt-pt, /nl-be, /en-gb) relative links like "/products/clear-otp" would open the
  // default (Dutch) store. Give them the market's path so visitors stay in their own language and currency.
  const localizeLinks = (scope = document) => {
    const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
    if (!root) return;
    scope.querySelectorAll('a[href^="/"]').forEach((link) => {
      const href = link.getAttribute('href');
      if (href.startsWith('//') || href === root || href.startsWith(`${root}/`) || href.startsWith('/cdn/')) return;
      link.setAttribute('href', `${root}${href}`);
    });
  };

  const setTrackingParameters = (scope = document) => {
    const parameters = new URLSearchParams(window.location.search);
    if (!parameters.size) return;
    scope.querySelectorAll('[data-listicle-cta]').forEach((link) => {
      try {
        const destination = new URL(link.href, window.location.origin);
        parameters.forEach((value, key) => {
          if (!destination.searchParams.has(key)) destination.searchParams.set(key, value);
        });
        link.href = destination.toString();
      } catch (_error) {
        return;
      }
    });
  };

  const initCarousels = (scope = document) => {
    scope.querySelectorAll('[data-listicle-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';
      const track = carousel.querySelector('[data-listicle-carousel-track]');
      if (!track) return;
      carousel.querySelector('[data-listicle-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.82, behavior: 'smooth' }));
      carousel.querySelector('[data-listicle-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.82, behavior: 'smooth' }));
    });
  };

  const initUrgency = (scope = document) => {
    scope.querySelectorAll('[data-listicle-urgency]').forEach((element) => {
      if (element.dataset.initialized === 'true') return;
      element.dataset.initialized = 'true';
      const locale = document.documentElement.lang || 'nl-NL';
      const month = new Intl.DateTimeFormat(locale, { month: 'long' }).format(new Date());
      const template = (element.dataset.template || '').replace('[maand]', month.charAt(0).toUpperCase() + month.slice(1));
      const days = Number.parseInt(element.dataset.days || '3', 10);
      const date = new Date();
      date.setDate(date.getDate() + days);
      const formattedDate = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(date);
      const parts = template.split('[datum]');
      if (parts.length === 1) {
        element.textContent = template;
        return;
      }
      element.replaceChildren(document.createTextNode(parts[0]), Object.assign(document.createElement('strong'), { textContent: formattedDate }), document.createTextNode(parts.slice(1).join('[datum]')));
    });
  };

  const init = (scope = document) => {
    localizeLinks(scope);
    setTrackingParameters(scope);
    initCarousels(scope);
    initUrgency(scope);
    requestUpdate();
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
